import { render, staticRenderFns } from "./ScreenPelvica.vue?vue&type=template&id=1a47db70&scoped=true&"
import script from "./ScreenPelvica.vue?vue&type=script&lang=js&"
export * from "./ScreenPelvica.vue?vue&type=script&lang=js&"
import style0 from "./ScreenPelvica.vue?vue&type=style&index=0&id=1a47db70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a47db70",
  null
  
)

export default component.exports